<div
    class="container-fluid"
    *ngIf="now; else emptyTpl"
>
    <div class="row">
        <div class="col">
            <h2>{{ now.name }}</h2>
            <span>{{ now.description }}</span>
        </div>
        <div
            class="col-4 next"
            *ngIf="next"
        >
            <a [routerLink]="['/', 'vimeo', 'video', next.playlistItemId]">
                <span class="h5">{{ i18n._8500_NEXT_VIDEO | translate }}</span>
                <span class="h3">{{ next.name }}</span>
            </a>
        </div>
    </div>
</div>

<ng-template #emptyTpl></ng-template>
